/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notify_CookInputs */

const en_notify_cook = /** @type {(inputs: Notify_CookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cook day`)
};

const de_notify_cook = /** @type {(inputs: Notify_CookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kochtag`)
};

/**
* | output |
* | --- |
* | "Cook day" |
*
* @param {Notify_CookInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const notify_cook = /** @type {((inputs?: Notify_CookInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notify_CookInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_notify_cook(inputs)
	return en_notify_cook(inputs)
});